import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { FeldKategoriesService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [FeldKategoriesService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class FeldKategoriesServiceModule {}
